import { AdOrderItemStatus } from '../enum';

export const adOrderItemStatusBadges: { [key in AdOrderItemStatus]: { text: string; classes: string } } = {
  [AdOrderItemStatus.DRAFT_OWNER]: {
    text: 'Черновик',
    classes: 'mat-tooltip-trigger bg-gray-100 text-gray-800 rounded-md px-2 py-1 text-xs',
  },
  [AdOrderItemStatus.AWAITING_PLACEMENT]: {
    text: 'Ожидает размещения',
    classes: 'mat-tooltip-trigger bg-amber-400 text-white rounded-md px-2 py-1 text-xs',
  },
  [AdOrderItemStatus.AWAITING_CONFIRMATION]: {
    text: 'Ожидает подтверждения',
    classes: 'mat-tooltip-trigger bg-amber-400 text-white rounded-md px-2 py-1 text-xs',
  },
  [AdOrderItemStatus.AWAITING_SETTINGS_DATE_PLACEMENT]: {
    text: 'Ожидает установки даты размещения',
    classes: 'mat-tooltip-trigger bg-amber-400 text-white rounded-md px-2 py-1 text-xs',
  },
  [AdOrderItemStatus.DECLINED]: {
    text: 'Отклонено',
    classes: 'mat-tooltip-trigger bg-red-400 text-white rounded-md px-2 py-1 text-xs',
  },
  [AdOrderItemStatus.PUBLISHING]: {
    text: 'Публикуется',
    classes: 'mat-tooltip-trigger bg-blue-400 text-white rounded-md px-2 py-1 text-xs',
  },
  [AdOrderItemStatus.PUBLISHED]: {
    text: 'Опубликовано',
    classes: 'mat-tooltip-trigger bg-green-100 text-green-800 rounded-md px-2 py-1 text-xs',
  },
  [AdOrderItemStatus.COMPLETE]: {
    text: 'Завершено',
    classes: 'mat-tooltip-trigger bg-green-200 text-green-800 rounded-md px-2 py-1 text-xs',
  },
  [AdOrderItemStatus.FAILED]: {
    text: 'Ошибка публикации',
    classes: 'mat-tooltip-trigger bg-red-400 text-white rounded-md px-2 py-1 text-xs',
  },
};
